module.exports = __webpack_public_path__ + "2f14fef664c9a38752b0a6edea098b31.pdf";